module.exports = __webpack_public_path__ + "static/media/Rectangle27.31c5e618.png";